import { dangerIconButtonStyles } from './DangerIconButton.styles';
import { filledIconButtonStyles } from './FilledIconButton.styles';
import { filledTonalIconButtonStyles } from './FilledTonalIconButton.styles';
import { outlinedIconButtonStyles } from './OutlinedIconButton.styles';
import { snackbarIconButtonStyles } from './SnackbarIconButton.styles';
import { standardIconButtonStyles } from './StandardIconButton.styles';
export const iconButtonVariantStyles = {
    danger: dangerIconButtonStyles,
    filled: filledIconButtonStyles,
    filledTonal: filledTonalIconButtonStyles,
    outlined: outlinedIconButtonStyles,
    snackbar: snackbarIconButtonStyles,
    standard: standardIconButtonStyles,
};
